var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoTableClear24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1115 18.3333L11.1109 36.3748L14.0263 37.9908L33.4378 2.97162L30.5224 1.35559L27.5784 6.66668H10.1856C9.66889 6.66668 9.17773 6.89668 8.8554 7.29168L2.04053 15.625C1.63122 16.1267 1.55107 16.8117 1.83587 17.39C2.11897 17.965 2.71587 18.3333 3.37076 18.3333H5.07789V33.3333H8.48873V18.3333H11.8996V25H15.3104V18.3333H21.1115ZM22.9592 15L25.7307 10H11.0059L6.91633 15H8.48191H11.8893H15.2968H22.9592ZM24.6903 25V24.7656L28.1011 18.6123V25H24.6903ZM31.512 18.3333H28.2558L30.1035 15H31.4847H33.0537L31.2952 12.8501L33.0571 9.67149L37.7521 15.4133C38.1085 15.7183 38.3337 16.1667 38.3337 16.6667C38.3337 17.5883 37.5713 18.3333 36.6299 18.3333H36.5958H34.9228V33.3333H31.512V18.3333Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTableClear24);
export default __webpack_public_path__ + "static/media/ico-table-clear-24.85e88366.svg";
export { ForwardRef as ReactComponent };